<template>
<div class="app-body">
  <WaitReceiverCard></WaitReceiverCard>
  <HelpCard></HelpCard>
</div>
</template>

<script>
import WaitReceiverCard from './wait-receiver-card.vue'
import HelpCard from './help-card.vue'
export default {
  name: 'index',
  components:{WaitReceiverCard,HelpCard}
}
</script>

<style  scoped>

</style>
